<template>
  <div class="lp-wrap">
    <!-- ── Left panel ── -->
    <div class="lp-left">
      <img
        :src="require('../../assets/login-panel.png')"
        alt="Pet Walkies"
        class="lp-panel-img"
      />
    </div>

    <!-- ── Right panel ── -->
    <div class="lp-right">
      <div class="lp-form">
        <!-- Mobile-only logo -->
        <div class="lp-mobile-logo">
          <img
            :src="require('../../assets/walkies-logo.png')"
            alt="Walkies"
            class="lp-mobile-logo__img"
          />
        </div>

        <h1 class="lp-title">Welcome back</h1>
        <p class="lp-subtitle">Sign in to continue to your dashboard.</p>

        <div class="lp-field-group">
          <label class="lp-label" for="login-email">Email address</label>
          <v-text-field
            id="login-email"
            v-model="form.email"
            outlined
            dense
            hide-details="auto"
            placeholder="admin@gmail.com"
            prepend-inner-icon="mdi-email-outline"
            :error-messages="errors.email"
            class="lp-field"
          />
        </div>

        <div class="lp-field-group">
          <label class="lp-label" for="login-password">Password</label>
          <v-text-field
            id="login-password"
            v-model="form.password"
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
            outlined
            dense
            hide-details="auto"
            placeholder="••••••••"
            prepend-inner-icon="mdi-lock-outline"
            :error-messages="errors.password"
            @keypress.enter="login"
            @click:append="showPassword = !showPassword"
            class="lp-field"
          />
        </div>

        <div class="lp-forgot">
          <v-btn text small color="#1a3d7c" to="/forgot-password" class="px-0">
            Forgot password?
          </v-btn>
        </div>

        <v-btn
          :loading="isLoading"
          :disabled="isLoading"
          color="#1a3d7c"
          block
          large
          depressed
          class="lp-signin-btn"
          @click="login"
        >
          Sign in
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import axios from "axios";

export default {
  name: "LoginPage",
  data() {
    return {
      form: {
        email: "",
        password: "",
        is_web: true,
      },
      showPassword: false,
      isLoading: false,
    };
  },
  mounted() {
    const companyId = localStorage.getItem("company-id");
    if (companyId && companyId.length) {
      this.getCompany(companyId);
    }
  },
  methods: {
    async getCompany(companyId) {
      await axios
        .get(`/get_company/${this.encryptIt(companyId)}`)
        .catch((error) => {
          console.error("Error fetching company:", error);
        });
    },
    ...mapActions({
      logIn: "auth/logIn",
    }),
    async login() {
      if (this.isLoading) return;
      this.isLoading = true;
      try {
        await this.logIn(this.form);
        location.reload("/");
      } catch (error) {
        this.isLoading = false;
        alert("User can't login in portal");
      }
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap');

/* ── Layout ── */
.lp-wrap {
  display: flex;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}

/* ── Left panel ── */
.lp-left {
  flex: 0 0 50%;
  max-height: 100vh;
  background: #EDF4FE;
  display: flex;
  align-items: stretch;
  overflow: hidden;
  position: sticky;
  top: 0;
}

.lp-panel-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center center;
  display: block;
}

/* ── Right panel ── */
.lp-right,
.lp-right * {
  font-family: 'Poppins', sans-serif !important;
}

.lp-right {
  flex: 0 0 50%;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 56px;
  overflow-y: auto;
}

.lp-form {
  width: 100%;
  max-width: 480px;
}

.lp-title {
  font-size: 2rem;
  font-weight: 700;
  color: #111827;
  margin-bottom: 6px;
  letter-spacing: -0.02em;
}

.lp-subtitle {
  font-size: 0.9rem;
  color: #6b7280;
  margin-bottom: 36px;
}

.lp-field-group {
  margin-bottom: 20px;
}

.lp-label {
  display: block;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 6px;
}

::v-deep .lp-field .v-input__slot {
  border-radius: 8px !important;
  background: #ffffff !important;
}

::v-deep .lp-field.v-input--is-focused .v-input__slot {
  border-color: #1a3d7c !important;
}

.lp-forgot {
  text-align: right;
  margin-top: -8px;
  margin-bottom: 28px;
}

.lp-signin-btn {
  height: 52px !important;
  border-radius: 8px !important;
  font-size: 1rem !important;
  font-weight: 600 !important;
  color: #ffffff !important;
  letter-spacing: 0.02em !important;
  text-transform: none !important;
}

/* ── Mobile logo (hidden on desktop) ── */
.lp-mobile-logo {
  display: none;
}

/* ── Responsive ── */
@media (max-width: 768px) {
  .lp-wrap {
    flex-direction: column;
    height: auto;
    overflow: auto;
  }

  .lp-left {
    display: none;
  }

  .lp-right {
    flex: 1;
    padding: 48px 24px 40px;
    min-height: 100vh;
    align-items: flex-start;
    padding-top: 60px;
  }

  .lp-form {
    width: 100%;
  }

  .lp-mobile-logo {
    display: flex;
    justify-content: center;
    margin-bottom: 28px;
  }

  .lp-mobile-logo__img {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    object-fit: contain;
  }
}
</style>
